module.exports = __webpack_public_path__ + "img/rainbow.2b6f48e9.png";